import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import React, { useState } from 'react';
import Form from '../../../../form/field';
import fieldLogic from '../logic/fieldsLogic';
import useInputRef from './useInputRef';
import Grid from '@material-ui/core/Grid';
import Description from '../controls/Description';
import useResizeObserver from '../../Run/components/useResizeObserver';

var FormFieldSignature = function FormFieldSignature(props) {
  var value = props.value,
      fieldId = props.fieldId,
      dispatch = props.dispatch;
  var description = props.description,
      placeholder = props.placeholder,
      error = props.error,
      active = props.active,
      readonly = props.readonly;
  var agreement = props.agreement,
      recipientName = props.recipientName,
      recipientRole = props.recipientRole,
      clearSignature = props.clearSignature;

  var _useInputRef = useInputRef(active),
      _useInputRef2 = _slicedToArray(_useInputRef, 1),
      inputRef = _useInputRef2[0];

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      width = _useState2[0],
      setWidth = _useState2[1];

  var resizedCallback = React.useCallback(function (entry) {
    if (entry && entry.contentRect) setWidth(entry.contentRect.width);
  }, []);
  var setObserver = useResizeObserver(resizedCallback);

  var onChange = function onChange(newValue) {
    fieldLogic.onChange(fieldId, newValue, dispatch);
  };

  var onFocus = function onFocus() {
    return fieldLogic.onFocus(fieldId, dispatch);
  };

  var onBlur = function onBlur() {
    return fieldLogic.onBlur(fieldId, dispatch);
  };

  return React.createElement(Grid, {
    style: {
      marginTop: 8,
      marginBottom: 4
    },
    ref: setObserver
  }, React.createElement(Form.Input.Signature, {
    agreement: agreement,
    recipientName: recipientName,
    recipientRole: recipientRole,
    error: error,
    helperText: description,
    placeholder: placeholder,
    disabled: readonly,
    value: value || '',
    variant: "filled",
    inputRef: inputRef,
    onBlur: onBlur,
    onFocus: onFocus,
    valueType: "xmlBase64",
    onChange: onChange,
    maxPadWidth: width,
    enableOnFocus: true,
    triggerSignatureChangeOnly: true,
    clearButtonContent: clearSignature
  }), React.createElement(Description, {
    error: error,
    description: description
  }));
};

export default React.memo(FormFieldSignature);